import { Scissors } from "lucide-react";
import { Reveal } from "./Reveal";
import { ANATOMY_IMAGE, ANATOMY_POINTS, ANATOMY_SIZE_RANGE } from "@/lib/svenData";

const AnatomyLabel = ({ point }) => (
  <div
    className={`hidden lg:block absolute max-w-[230px] ${
      point.align === "right" ? "text-right -translate-x-full" : "text-left"
    }`}
    style={{ top: point.top, left: point.left }}
  >
    <div className="bg-[#0b0b0c]/75 backdrop-blur-md px-4 py-3 rounded-sm border border-white/10">
      <p className="font-display text-sm text-[#faf8f5] mb-1">{point.title}</p>
      <p className="text-[11px] font-light leading-relaxed text-white/60">{point.desc}</p>
    </div>
  </div>
);

export const Anatomy = () => (
  <section id="anatomy" data-testid="anatomy-section" className="bg-[#060d1d] py-24 lg:py-10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline-label mb-2 text-center">The Craft</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-medium text-[#faf8f5] mb-4 max-w-2xl mx-auto text-center">
          The Anatomy of <em className="font-accent text-[#dfcca4]">a Sven Suit Jacket.</em>
        </h2>
        <p className="text-sm font-light text-white/55 max-w-xl mx-auto text-center mb-16">
          Every Sven jacket begins with a hand-cut canvas and ends with a finish
          you can feel. Here's a closer look at what goes into the coat before
          it ever reaches a fitting room.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="relative max-w-xl mx-auto">
          <img
            data-testid="anatomy-image"
            src={ANATOMY_IMAGE}
            alt="Sven Suits jacket construction detail"
            className="w-full aspect-[2/3] object-cover rounded-sm"
          />
          {ANATOMY_POINTS.map((p) => (
            <AnatomyLabel key={p.id} point={p} />
          ))}
        </div>

        {/* Mobile fallback — overlay labels are desktop-only (hidden lg:block above) */}
        <div className="lg:hidden grid sm:grid-cols-2 gap-6 mt-10 max-w-2xl mx-auto">
          {ANATOMY_POINTS.map((p) => (
            <div key={p.id} data-testid={`anatomy-point-mobile-${p.id}`} className="border-t border-white/10 pt-4">
              <p className="font-display text-sm text-[#faf8f5] mb-1">{p.title}</p>
              <p className="text-[11px] font-light leading-relaxed text-white/60">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-2 mt-14">
          <Scissors size={14} className="text-[#c5a059]" />
          <p className="font-mono-ov text-[11px] tracking-[0.2em] uppercase text-[#dfcca4]">
            {ANATOMY_SIZE_RANGE}
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);